export const toSnakeCase = (json) =>
  Object.keys(json).reduce((acc, key) => {
    const snakeCaseKey = key.replace(/[A-Z]/g, letter => `_${ letter.toLowerCase() }`);
    acc[snakeCaseKey] = json[key];
    return acc;
  }, {});
